// import { isWeiXin } from './util';
let ajax = require('../common/ajax/ajax.js');
import { getParam } from './util'
import MobileDetect from 'mobile-detect'

const md = new MobileDetect(window.navigator.userAgent)
export default {
  methods: {
    downloadApp() {
      let appChannel = getParam('appChannel')
      const newAppChannel = `${appChannel}&flowPath=${this.pageDetail}`
      if (this.mode === 'mini-app') {
        const pathMap = {
          'applyPage': 'pages/home/index',  // 完件（首页）
          'cashLoan': 'pages/home/index', // 借款（首页）
          'myRepayment': 'pages/prepay/list/index',  // 我要还款
          'repayRecord': 'pages/receipt/list/index',  // 借还记录
          'myCoupon': 'pages/coupon/home/index', // 我的优惠券（首页）
          'repayAgreementPage': 'pages/home/index', // 协议支付管理（首页）（暂时）
          'bankCardPage': 'pages/home/index', // 银行卡管理（首页）（暂时）
        }
        const params = {
          // appChannel: appChannel || '',
          appChannel: appChannel ? newAppChannel : '',
          service: 'wxAppletJsj',
          path: pathMap[this.pageDetail]
        }
        this.getMiniAppScheme(params)
        return
      }

      if (md.os() === 'iOS') {
        // 跳转小程序
        const params = {
          appChannel: appChannel || '',
          service: 'wxAppletJsj',
        }
        if (this.mode === 'short-link') {
          const pathMap = {
            'applyPage': 'pages/home/index',  // 完件（首页）
            'cashLoan': 'pages/home/index', // 借款（首页）
            'myRepayment': 'pages/prepay/list/index',  // 我要还款
            'repayRecord': 'pages/receipt/list/index',  // 借还记录
            'myCoupon': 'pages/coupon/home/index', // 我的优惠券（首页）
          }
          params.path = pathMap[this.pageDetail]
          params.appChannel = appChannel ? newAppChannel : ''
        }
        this.getMiniAppScheme(params)
      // location.href = 'https://apps.apple.com/us/app/%E6%96%B0%E5%B0%8F%E8%8A%B1%E9%92%B1%E5%8C%85/id1580545905';
      } else if (md.os() === 'AndroidOS') {
        // location.href = "https://dl.xh1.cn/android-dis/release/android5.2.4_dns/2021/02/08/117/xhqb01_xhqb_release_5.2.4_94_117.apk";
        if (this.mode === 'short-link') {
          location.href = `xhqball://open?query=${this.pageDetail}`
        } else {
          location.href = 'xhqball://open'
        } 
        setTimeout(() => {
          location.href = 'https://dl.xhqbapp.com/Android/prod/xhqb01.apk'
        },3000)
      }
    },
    getMiniAppScheme (params) {
      let _this = this;
      ajax.get(
        _this,
        '/weixinh5/weixin/getUrlScheme',
        {
          params
        },
        function(resp) {
          if (resp.success) {
            location.href = resp.urlScheme
          } else {
            _this.$refs.toast.show(resp.resultMsg);
          }
        },
        function() {}
      )
    }
  }
}


// WEBPACK FOOTER //
// ./web/js/common/download-app.js